// src/pages/Wallet/components/NFTList.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import NFTItem from './NFTItem';
import './NFTList.css';

const NFTList = ({ nfts, onNFTClick, isLoading = false }) => {
  const { t } = useTranslation();
  
  // Show loading state
  if (isLoading) {
    return (
      <div className="nft-list">
        <div className="nft-grid">
          {/* Loading placeholders */}
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className="nft-item-placeholder">
              <div className="nft-image-placeholder-skeleton"></div>
              <div className="nft-info-placeholder">
                <div className="nft-name-placeholder"></div>
                <div className="nft-collection-placeholder"></div>
                <div className="nft-tokenid-placeholder"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
  
  // Show empty state
  if (!nfts || nfts.length === 0) {
    return (
      <div className="nft-list">
        <div className="nft-empty-state">
          <div className="nft-empty-icon">
            <svg
              width="80"
              height="80"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1"
            >
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
              <circle cx="8.5" cy="8.5" r="1.5"/>
              <polyline points="21,15 16,10 5,21"/>
            </svg>
          </div>
          <h3 className="nft-empty-title">
            {t('wallet.nft.noNFTsFound', 'No NFTs Found')}
          </h3>
          <p className="nft-empty-description">
            {t('wallet.nft.noNFTsDescription', 'You don\'t have any NFTs in this wallet yet.')}
          </p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="nft-list">
      <div className="nft-grid">
        {nfts.map((nftObj, index) => (
          <NFTItem
            key={`${nftObj.nft.contractAddress}-${nftObj.nft.tokenId}`}
            nftObj={nftObj}
            onClick={onNFTClick}
          />
        ))}
      </div>
      
      {/* Show collection summary */}
      {nfts.length > 0 && (
        <div className="nft-summary">
          <span className="nft-count">
            {t('wallet.nft.totalNFTs', '{{count}} NFT', { count: nfts.length })}
          </span>
          
          {/* Show unique collections count */}
          {(() => {
            const uniqueCollections = new Set(
              nfts.map(nft => nft.nft.contractAddress.toLowerCase())
            ).size;
            
            if (uniqueCollections > 1) {
              return (
                <span className="collection-count">
                  {t('wallet.nft.fromCollections', 'from {{count}} collection', { count: uniqueCollections })}
                </span>
              );
            }
            return null;
          })()}
        </div>
      )}
    </div>
  );
};

export default NFTList;